module.exports = __webpack_public_path__ + "static/img/noquanxian.5aac6e02.png";